import React, { useCallback, useMemo } from 'react';
import { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';
import { ISupplier } from 'types';
import FormInput from 'components/Input/FormInput';

interface IProps {
	changeSupplierTaxpayerId: (value: string) => void;
	supplierPhone: ISupplier['phone'];
	supplierName: ISupplier['name'];
}

export const SupplierTaxIDField: React.FC<IProps> = React.memo(
	({ changeSupplierTaxpayerId, supplierPhone, supplierName }) => {
		const { t } = useTranslation('error');

		const validationRules = useMemo<Rule[]>(
			() => [
				{ required: !!(supplierPhone || supplierName), message: t('enterTaxID') },
				// ({ getFieldValue }) => ({
				() => ({
					validator(_, value) {
						// if (!value && (getFieldValue('supplierPhone') || getFieldValue('supplierName'))) {
						// 	return Promise.reject(new Error(t('enterTaxID')));
						// } else if (value && value.length !== 10 && value.length !== 12) {
						if (value && value.length !== 10 && value.length !== 12) {
							return Promise.reject(new Error(t('supplierTaxIdShouldContainCertainNumberOfDigits')));
						}
						return Promise.resolve();
					},
				}),
			],
			[t, supplierPhone, supplierName],
		);

		const handleChange = useCallback(
			(e: React.ChangeEvent<HTMLInputElement>) => {
				const onlyDigits = e.target.value.replace(/\D/g, '').slice(0, 12);
				changeSupplierTaxpayerId(onlyDigits);
				return onlyDigits;
			},
			[changeSupplierTaxpayerId],
		);

		return (
			<FormInput
				testId="SupplierTaxIDField"
				name="supplierTaxpayerId"
				label="supplierTaxIDLabel"
				getValueFromEvent={handleChange}
				validationRules={validationRules}
			/>
		);
	},
);
